// Despatch statuses
window.SFDepatchStatuses = [
    '4-5 working days'
]
window.SFDefaultDespatchStatus = 'same day before 1pm / next working day'

// Cart lock
window.sf_cart_lock = false;

document.addEventListener("product:variant-change", function (evt) {
    //console.log('Variant changed');
    let variant = evt.detail.variant
    if (variant.featured_image && SFSwiperApi) {
        let pos = variant.featured_image.position
        SFSwiperApi.slideTo(pos-1);
        let elements = document.querySelectorAll('[data-media-thumbnail]');
        elements.forEach(function(el) {
            el.classList.remove('is--active');
        });
        let active = document.querySelector('[data-media-swiper-id="'+pos+'"]');
        active.classList.add('is--active')
    } else {
        console.info('Variant changed, but no media associated with this colour')
    }
    
    let sku = document.querySelectorAll('[data-product-sku]');
    sku.forEach(function(el) {
        el.innerHTML = variant.sku
    });
    
    //let SFVariantSelects = customElements.get('variant-selects');
    //console.log(SFVariantSelects);
    //SFVariantSelects.chan
    
    /*let rrpContainer = document.getElementsByClassName('sf--rrp-container')[0];
    if(rrpContainer !== undefined) {
        let rrpHolder = rrpContainer.getElementsByClassName('sf--product-rrp')[0];
        if(rrpHolder !== undefined) {
            console.log('Update RRP');
            let rrpPrice = rrpHolder.getElementsByTagName('span')[0];
            if(rrpPrice !== undefined) {
                let symbol = rrpPrice.dataset.currencySymbol;
                if(variant.compare_at_price > variant.price) {
                    let compareAtPrice = variant.compare_at_price / 100;
                    rrpPrice.textContent = symbol + compareAtPrice.toFixed(2);
                    rrpContainer.classList.remove('sf--hidden');
                } else {
                    rrpContainer.classList.add('sf--hidden');
                    rrpPrice.textContent = '';
                }
            }
        }
    }*/
    
    SFUpdateLeadTime(evt.detail.variant);
    
    SFUpdateComponents(evt.detail.variant);
});


document.addEventListener('DOMContentLoaded', function() {
    let elements = document.querySelectorAll('[data-media-thumbnail]');
    elements.forEach(function(element) {
        element.addEventListener('click', function() {
            if (SFSwiperApi) {
                elements.forEach(function(el) {
                    el.classList.remove('is--active');
                });
                this.classList.add('is--active');
                let pos = this.getAttribute('data-media-swiper-id');
                SFSwiperApi.slideTo(pos-1)
            }
        });
    });
    
    if(typeof window.SFProductVariant == 'object') {
        console.log('Setting default dispatch dates');
        
        console.log('Triggering variant update');
        let evtDetail = {
          variant: window.SFProductVariant
        };
        document.documentElement.dispatchEvent(new CustomEvent('product:variant-change', {
          bubbles: true,
          detail: evtDetail
        }));
        
        //SFUpdateLeadTime(window.SFProductVariant);
    }
    
    if(typeof window.SFComponents == 'object') {
        
        // Set initial components
        SFUpdateComponents(window.SFProductVariant);
        
        //console.log('Override add to cart button');
        let submit_button = document.getElementById('AddToCart');
        
        submit_button.addEventListener('click', function(e) {
            //console.log('Overwriting submit button');
            e.preventDefault();
            let //qty = parseInt(document.getElementsByClassName('qty')[0].value),
                qty = 1,
                errors = [],
                despatchTime = document.getElementById('expected_despatch_time').value,
                properties = {
                    'Expected despatch time': despatchTime
                };
            //console.log('Despatch time: ' + despatchTime);
            //console.log(window.SFComponents);
            // Validate
            if(typeof window.SFComponents.shell.id === 'undefined' || typeof window.SFComponents.liner.id === 'undefined') {
                errors.push('There was a problem adding the product to the cart - missing item');
            } else if(window.SFComponents.shell.available !== true || window.SFComponents.liner.available !== true) {
                errors.push('There was a problem adding the product to the cart - item unavailable');
            } 
            
            //console.log('Errors:');
            //console.log(errors);
            if(errors.length == 0) {
                
                let totalPrice = (window.SFComponents.shell.price + window.SFComponents.liner.price),
                    productTitle = window.SFComponents.shell.product_title,
                    _id = Math.floor(Math.random() * 1000000),
                    shellProperties = {
                        'Expected despatch time': despatchTime,
                        '_id': _id,
                        '_total_price': totalPrice,
                        '_product_title': productTitle
                    },
                    linerProperties = {
                        'Expected despatch time': despatchTime,
                        'For': window.SFComponents.shell.product_title,
                        '_parent_id': _id
                    };
                //console.log(shellProperties);
                //console.log(linerProperties);
                
                let cart_url = window.Shopify.routes.root + 'cart/add.js',
                    shell = {
                        id: window.SFComponents.shell.id,
                        quantity: qty,
                        properties: shellProperties
                    },
                    liner = {
                        id: window.SFComponents.liner.id,
                        quantity: qty,
                        properties: linerProperties
                    },
                    items = [liner,shell],
                    formData = {
                        'items': items
                    };
                
                //console.log('Items to add');
                //console.log(items);
                
                //return false;
                window.sf_cart_lock = true;
                fetch(cart_url, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(formData)
                })
                .then(response => {
                    // Unlock cart
                    window.sf_cart_lock = false;
                    // Check for quick cart and redirect
                    console.log(response);
                    // Redirect to cart
                    //console.log('Redirect');
                    window.location.href = '/cart';
                    //window.dispatchEvent("cart:updated", {
                    //    cart: cart
                    //  });
                    //return false;
                })
                .catch((error) => {
                    window.sf_cart_lock = false;
                  console.error('Error:', error);
                });
            } else {
                alert(errors.join('\n'));
            }
        });
    }
    
    const myCartWatcher = new CartWatcher;
    myCartWatcher.init();
    //window.addEventListener("cart_changed", e => console.log(e.detail));

    window.addEventListener('cart_changed', function(evt) {
    //debugger
    console.log('Cart updated...');
        //console.log(evt.detail);
        //console.log('Waiting...');
        //setTimeout(window.Surefire.check_cart_accessories(evt.detail.cart.items), 5000);
        if(!window.sf_cart_lock) {
            SFCheckCartAccessories(evt.detail.cart.items);
        }
    });
    
    let selects = document.getElementsByTagName('variant-selects')[0];
    selects.dispatchEvent(new Event("change"));
});

function SFUpdateLeadTime(variant) {
    // Only do this for non-helmet builder products
    if(typeof window.SFComponents != 'object') {
        // URL for metafield data
        let url = '/products/' + window.SFProduct.handle + '/?variant=' + variant.id + '&view=variant-metafields';
        //console.log(url);
        SFGetJSON(url,
        function(err, data) {
          if (err !== null) {
            console.log('Something went wrong: ' + err);
          } else {
              let SFProductLeadTime = data.lead_time,
                  SFProductDespatchTime = document.getElementById('expected_despatch_time'),
                  SFProductLeadTimeContainer = document.getElementsByClassName('product-inventory-notice')[0],
                  SFPickupContainer = document.getElementsByClassName('pickup-availability-wrapper')[0];
              SFPickupContainer.fetchAvailability(SFPickupContainer.dataset.variantId);
              //SFProductLeadTimeContainer.classList.remove('product-inventory-notice--normal');
              SFProductLeadTimeContainer.style.display = 'none';
                //SFProductLeadTimeContainer.classList.remove('product-inventory-notice--low');
              SFProductDespatchTime.value = SFProductLeadTime;

              // &  Make sure we show the message in case of AJAX delay
                setTimeout(() => {
                    SFProductLeadTimeContainer.style.display = 'block';
                }, 1000);
              
              if(SFPickupContainer != null) {
                  
                  var spans = document.querySelectorAll('span[data-lead-time-text]');
                    
                  SFPickupContainer.style.display = 'none';
                  SFPickupContainer.dataset.leadTime = SFProductLeadTime;
                  setTimeout(() => {
                      spans.forEach(function(span) {
                      span.textContent = SFProductLeadTime;
                    });
                    
                }, 1000);
                  
                  setTimeout(() => {
                      var spans2 = document.querySelectorAll('span[data-lead-time-text]');
                      spans2.forEach(function(span) {
                      span.textContent = SFProductLeadTime;
                    });
                      
                      /*let pickupButton = document.querySelectorAll('[data-sf-pickup-button]')[0];
                      if (pickupButton) pickupButton.addEventListener('click', (evt) => {
                        document.getElementById('Pickup-Availability').classList.toggle("active");
                        document.getElementsByTagName("body")[0].classList.toggle('open-cc');

                        evt.preventDefault();
                      });*/
                      
                      SFPickupContainer.style.display = 'block';
                }, 2000);
              }

          }
        });
    }
}

function SFUpdateComponents(variant) {
    console.log('Updating components');
    //console.log(variant);
    //console.log('Handle: ' + window.SFProduct.handle);
    //console.log(typeof window.SFComponents);
    if(typeof window.SFComponents == 'object') {
        //console.log('Component product');
        let url = '/products/' + window.SFProduct.handle + '/?variant=' + variant.id + '&view=component-data';
        //console.log(url);
        SFGetJSON(url,
        function(err, data) {
          if (err !== null) {
            console.log('Something went wrong: ' + err);
          } else {
            console.log(data);
              window.SFComponents = data;
              //console.log('Component data:');
              //console.log(window.SFComponents);
              let despatchStatusLength = window.SFDepatchStatuses.length,
                    SFProductLeadTime = window.SFDefaultDespatchStatus,
                    SFProductDespatchTime = document.getElementById('expected_despatch_time'),
                    SFProductLeadTimeContainer = document.getElementsByClassName('product-inventory-notice')[0],
                    SFProductLeadTimeText = document.getElementsByClassName('product-inventory-notice--text')[0],
                    available = true,
                    submitButton = document.getElementById('AddToCart'),
                    SFPickupContainer = document.getElementsByClassName('pickup-availability-wrapper')[0];;
                
                SFProductLeadTimeContainer.style.display = 'none';
                SFProductLeadTimeContainer.classList.remove('product-inventory-notice--low');
                SFProductLeadTimeContainer.classList.remove('product-inventory-notice--normal');
                
                if(window.SFComponents.shell.available !== true || window.SFComponents.liner.available !== true) {
                    available = false;
                }
                //console.log('Available: ' + available);
                if(available) {
                    SFProductLeadTimeContainer.classList.add('product-inventory-notice--normal');
                    for(let i=0;i<despatchStatusLength;i++) {
                        if(window.SFComponents.shell.lead_time == window.SFDepatchStatuses[i] || window.SFComponents.liner.lead_time == window.SFDepatchStatuses[i]) {
                            SFProductLeadTime = window.SFDepatchStatuses[i];
                            break;
                        }
                    }
                    //console.log('Expected despatch time:' + SFProductLeadTime);
                    submitButton.disabled = false;

                } else {
                    SFProductLeadTimeContainer.classList.add('product-inventory-notice--low');
                    SFProductLeadTime = 'Unavailable';
                    submitButton.disabled = true;
                }
              
              SFProductDespatchTime.value = SFProductLeadTime;
                SFProductLeadTimeText.textContent = 'Expected despatch time: ' + SFProductLeadTime;
                // &  Make sure we show the message in case of AJAX delay
              //console.log('Pickup container');
              //console.log(SFPickupContainer);
              if(SFPickupContainer != null) {
                  
                  var spans = document.querySelectorAll('span[data-lead-time-text]');
                    
                  SFPickupContainer.style.display = 'none';
                  SFPickupContainer.dataset.leadTime = SFProductLeadTime;
                  setTimeout(() => {
                      spans.forEach(function(span) {
                      span.textContent = SFProductLeadTime;
                    });
                    
                }, 1000);
                  
                  setTimeout(() => {
                      var spans2 = document.querySelectorAll('span[data-lead-time-text]');
                      spans2.forEach(function(span) {
                      span.textContent = SFProductLeadTime;
                    });
                      
                      /*let pickupButton = document.querySelectorAll('[data-sf-pickup-button]')[0];
                      console.log('Pickup button');
                      console.log(typeof pickupButton);
                      if (typeof pickupButton !== "undefined") {
                            pickupButton.addEventListener('click', (evt) => {
                            document.getElementById('Pickup-Availability').classList.add("active");
                            document.getElementsByTagName("body")[0].classList.add('open-cc');

                            evt.preventDefault();
                          });  
                      } */
                      
                      SFPickupContainer.style.display = 'block';
                }, 2000);
              }
              
              setTimeout(() => {
                  if(available) {
                      submitButton.disabled = false;
                  } else {
                      submitButton.disabled = true;
                  }
                    SFProductLeadTimeContainer.style.display = 'block';
                }, 1000);

          }
        });
    } else {
        console.log('Standard product');
    }
}

function SFGetJSON(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'json';
    xhr.onload = function() {
      var status = xhr.status;
      if (status === 200) {
        callback(null, xhr.response);
      } else {
        callback(status, xhr.response);
      }
    };
    xhr.send();
}

/**
 Check cart for orphaned accessories
 */
function SFCheckCartAccessories(cart_items) {

    console.log('Checking accessories');
    //console.log(window.sf_cart_lock);
    let to_remove = [];
    let to_update = [];
    //console.log(cart_items);
    cart_items.forEach((line_item, index, array) => {
        //console.log('ID: ' + line_item.properties._id);
        if(line_item.properties && line_item.properties._parent_id !== undefined) {
            let accessory_key = line_item.key,
                parent_id = line_item.properties._parent_id,
                parent_found = false;
            //console.log('Parent: ' + line_item.properties._parent_id);
            cart_items.forEach((parent, index, array) => {
                if(parent.properties._id !== undefined) {
                    if(parent.properties._id == parent_id) {
                        parent_found = true;
                        //console.log('Parent found');
                        //console.log(parent);
                        let new_qty = parent.quantity;
                        if(parent.quantity != line_item.quantity) {
                            to_update.push({'id': accessory_key, 'quantity': parent.quantity});
                        }
                    }
                }
            });
            //console.log(parent_found);
            if(!parent_found) {
                //to_remove.push(accessory_key);
                to_update.push({'id': accessory_key, 'quantity': 0});
            } /*else {
                to_update.push = ({'id': accessory_key, 'quantity': new_qty});
            }*/
        }
    });

    //console.log('To update');
    //console.log(to_update);

    //let refresh = false;

    if(to_update.length > 0) {
        let updates = {};
        to_update.forEach((item) => {
            //console.log(item);
            updates[item.id] = item.quantity;
        });
        //console.log(updates);
        let cart_url = window.Shopify.routes.root + 'cart/update.js';
        let formData = {
             'updates': updates
            };
            fetch(cart_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
                console.log('Accessories updated');
                //location.reload();
                location.href='/cart';
            })
            .catch((error) => {
              console.error('Error:', error);
            });
    }
}


class CartWatcher {

  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

 storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

 findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach(oi => {
      const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0
        ? result.added.push(item)
        : result.removed.push(item)
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);
    
    if(!window.sf_cart_lock) {
        const event = new CustomEvent("cart_changed", { detail: { changes: changes, cart: newCart }});
        window.dispatchEvent(event);

        this.storeCart(newCart);
    }
  }

 observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}

/*function SFPickupAvailability() {
    var pickupAvailability = document.querySelector('pickup-availability');
    var leadTime = pickupAvailability.getAttribute('data-lead-time');
    var spans = document.querySelectorAll('span[data-lead-time-text]');
    console.log('Lead time: ' + leadTime);
    spans.forEach(function(span) {
      span.textContent = leadTime;
    });
}

const targetNode = document.getElementById('Pickup-Availability');
const config = { childList: true, subtree: true };
const SFPickupAvailabilityCallback = function(mutationsList, observer) {
    for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            SFPickupAvailability();
        }
    }
};

const observer = new MutationObserver(SFPickupAvailabilityCallback);
observer.observe(targetNode, config);*/

// observer.disconnect();